<div class="project-page">
  <header class="project-header">
    <p class="eyebrow">Portfolio :: Endless Blow</p>
    <h1>Endless Blow</h1>
    <div class="meta-badges">
      <span>Android</span>
      <span>Java</span>
      <span>SQLite</span>
      <span>Game</span>
    </div>
  </header>

  <div class="content-grid">
    <section class="project-copy">
      <p>
        Multiplayer RPG Game
      </p>

      <ul class="feature-list">
        <li>Character progression and level-based development.</li>
        <li>Complex and innovative attack mode.</li>
        <li>Online gameplay.</li>
        <li>Online chat with another players and private messages.</li>
      </ul>

      <div class="project-actions">
        <a class="project-link" target="_blank"
           href="https://play.google.com/store/apps/details?id=pl.jawegiel.endlessblow&hl=en">Download on Google
          Play</a>
      </div>
    </section>

    <aside class="project-visual screenshot-gallery">
      <img class="phone-shot" src="../../../../assets/images/endless_blow_screen1_en.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/endless_blow_screen2_en.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/endless_blow_screen3_en.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/endless_blow_screen4_en.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/endless_blow_screen5_en.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/endless_blow_screen6_en.png" alt="Endless Blow screenshot">
    </aside>
  </div>

  <section class="user-info">
    <button type="button" (click)="doGetUsersInfo()">Show info about users (only logged users)</button>
    <p class="status-message">{{ waitForResponseFromInfo1 }}</p>

    <div class="info-table" *ngIf="usersWithInfo!==undefined">
      <table>
        <thead>
        <tr>
          <th>Name</th>
          <th>Registration date</th>
          <th>Last visited</th>
          <th>Is online</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let user of usersWithInfo">
          <td>{{ user.name }}</td>
          <td>{{ user.reg_date }}</td>
          <td>{{ user.last_visited }}</td>
          <td>{{ user.is_logged }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="info-table" *ngIf="usersWithInfo!==undefined">
      <table>
        <thead>
        <tr>
          <th>Name</th>
          <th>Level</th>
          <th>Exp</th>
          <th>Gold</th>
          <th>Hp</th>
          <th>Mp</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let user of usersWithInfo">
          <td>{{ user.name }}</td>
          <td>{{ user.level }}</td>
          <td>{{ user.exp }}</td>
          <td>{{ user.gold }}</td>
          <td>{{ user.hp }}</td>
          <td>{{ user.mp }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
